module.exports = __webpack_public_path__ + "static/media/spain-icon.33ae12b0.svg";